(function () {
    'use strict';

    function yesNoQuestionConfiguration() {
        return {
            restrict: 'E',
            templateUrl: 'siteConfiguration/directives/templates/yesNoQuestionConfiguration.html',
            link: function (scope) {

            }
        };
    }

    yesNoQuestionConfiguration.$inject = [];

    angular.module('ecap.siteConfiguration').directive('yesNoQuestionConfiguration', yesNoQuestionConfiguration);
})();
